module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[110]353.0f9cb45.woff2";